<script>
import BaseFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter.vue';
import { DevicesService } from '@/services/devices.service';

export default {
  name: 'FirstNameFilter',

  extends: BaseFilter,

  data() {
    return {
      name: 'first_name'
    };
  },

  methods: {
    getData() {
      return DevicesService.getFilteredFirstNames({ search: this.search })
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
